export default __webpack_public_path__ + "static/media/imagen_familia.16b70153.png";